import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.jpg";
import { LogOut, LayoutDashboard } from "lucide-react";

export function SiteHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => { await logout(); navigate("/login"); };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-brand-bg/80 border-b border-brand-line">
      <div className="max-w-6xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to={user ? (user.role === "admin" ? "/admin" : "/dashboard") : "/"} className="flex items-center gap-3" data-testid="header-logo-link">
          <img src={logo} alt="Rehoboth Wealth Management" className="h-12 md:h-14 w-auto object-contain" />
          <span className="hidden sm:block font-serif text-lg font-semibold text-brand-green leading-tight">
            Rehoboth Wealth<span className="block text-[10px] tracking-widest text-brand-gold font-sans font-semibold -mt-1">GROUP</span>
          </span>
        </Link>
        <div className="flex items-center gap-2 md:gap-3">
          {user ? (
            <>
              <Button variant="ghost" size="sm" className="text-brand-ink hover:text-brand-green" onClick={() => navigate(user.role === "admin" ? "/admin" : "/dashboard")} data-testid="header-dashboard-btn">
                <LayoutDashboard className="w-4 h-4 mr-1.5" /> Dashboard
              </Button>
              <span className="hidden md:inline text-sm text-brand-muted">{user.name}</span>
              <Button variant="outline" size="sm" onClick={handleLogout} data-testid="header-logout-btn"
                className="border-brand-line text-brand-green hover:bg-brand-admin">
                <LogOut className="w-4 h-4 mr-1.5" /> Sign out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/login")} data-testid="header-login-btn" className="text-brand-green">Sign in</Button>
              <Button size="sm" onClick={() => navigate("/register")} data-testid="header-register-btn"
                className="bg-brand-green hover:bg-brand-greenHover text-white">Get started</Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
